import React from 'react'

const Home = () => {
    return (
        <div className="home">
            <img src="/img/antenna-logo.png" alt="home-logo" height="200px" width="200px" />
            <h2>Welcome to the Comms Calculator!</h2>
            <h5>Calculate your device and network metrics.</h5>
        </div>
    )
}

export default Home